import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    type: String, 
    duration: Number 
  }
  
  connect() {
    console.log("Flash controller connected!")
    this.setupAutoHide()
    this.setupHoverPause()
    this.animateIn()
  }
  
  setupAutoHide() {
    if (this.durationValue > 0) {
      this.hideTimer = setTimeout(() => {
        this.hide()
      }, this.durationValue)
    }
  }
  
  setupHoverPause() {
    this.element.addEventListener("mouseenter", this.pauseTimer.bind(this))
    this.element.addEventListener("mouseleave", this.resumeTimer.bind(this))
  }
  
  pauseTimer() {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer)
      this.hideTimer = null
    }
  }
  
  resumeTimer() {
    if (this.durationValue > 0 && !this.hideTimer) {
      this.hideTimer = setTimeout(() => {
        this.hide()
      }, 2000) // 2 secondes après avoir quitté le survol
    }
  }
  
  animateIn() {
    this.element.style.transform = "translateX(100%)"
    this.element.style.opacity = "0"
    
    requestAnimationFrame(() => {
      this.element.style.transition = "all 300ms ease-out"
      this.element.style.transform = "translateX(0)"
      this.element.style.opacity = "1"
    })
  }
  
  hide() {
    this.element.style.transition = "all 300ms ease-out"
    this.element.style.transform = "translateX(100%)"
    this.element.style.opacity = "0"
    
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
  
  close() {
    console.log("Flash close button clicked!")
    this.hide()
  }
  
  disconnect() {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer)
    }
  }
}